// initial state
const state = {
  IfShowAppDownloadGuide: false, // 是否展现预约提醒引导下载APP配置
  IfShowAppReserveRemind: false, // APP是否展现预约提醒
  guideToAppPopupInfo: {
    isShow: false,
    title: undefined,
    desc: undefined,
    isLinkToApp: true
  }
}

// getters
const getters = {
  getGuideToAppPopupInfo: (state) => state.guideToAppPopupInfo,
  getIfShowAppDownloadGuide: (state) => state.IfShowAppDownloadGuide,
  getIfShowAppReserveRemind: (state) => state.IfShowAppReserveRemind
}

// mutations
const mutations = {
  SET_GUIDE_TO_APP_POPUP_INFO(state, guideToAppPopupInfo) {
    state.guideToAppPopupInfo = guideToAppPopupInfo
  },
  SET_IF_SHOW_APP_DOWNLOAD_GUIDE(state, IfShowAppDownloadGuide) {
    state.IfShowAppDownloadGuide = IfShowAppDownloadGuide
  },
  SET_IF_SHOW_APP_RESERVE_REMIND(state, IfShowAppReserveRemind) {
    state.IfShowAppReserveRemind = IfShowAppReserveRemind
  }
}
// actions
const actions = {}

export default {
  state,
  getters,
  actions,
  mutations
}
